import { jsxs, jsx } from 'react/jsx-runtime';
import 'react';

const YozmITSymbolText = ({ className, variant })=>{
    if (variant === 'white') return /*#__PURE__*/ jsxs("svg", {
        width: "80",
        height: "20",
        viewBox: "0 0 80 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        "data-testid": "design-system-logo--yozmIT-symbol-text-white",
        children: [
            /*#__PURE__*/ jsxs("g", {
                clipPath: "url(#clip0_5400_8961)",
                children: [
                    /*#__PURE__*/ jsx("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M39.1111 11.7375C38.4395 11.7375 37.8017 11.6574 37.1972 11.4966V15.372H41.025V11.4966C40.3981 11.6574 39.7602 11.7375 39.1111 11.7375ZM39.1111 4.66251C38.63 4.66251 38.1737 4.71989 37.7428 4.83466C37.3121 4.94925 36.9312 5.11288 36.6012 5.3252C36.2711 5.5377 36.0108 5.79849 35.8208 6.10834C35.6302 6.41819 35.5354 6.76232 35.5354 7.1411V7.79546C35.5354 8.17425 35.6302 8.51838 35.8208 8.82823C36.0108 9.13807 36.2711 9.39925 36.6012 9.61156C36.9312 9.82406 37.3121 9.98751 37.7428 10.1021C38.1737 10.2171 38.63 10.2742 39.1111 10.2742C39.5921 10.2742 40.0485 10.2171 40.4794 10.1021C40.9101 9.98751 41.2908 9.82406 41.6211 9.61156C41.9511 9.39925 42.2112 9.13807 42.4014 8.82823C42.5919 8.51838 42.687 8.17425 42.687 7.79546V7.1411C42.687 6.76232 42.5919 6.41819 42.4014 6.10834C42.2112 5.79849 41.9511 5.5377 41.6211 5.3252C41.2908 5.11288 40.9101 4.94925 40.4794 4.83466C40.0485 4.71989 39.5921 4.66251 39.1111 4.66251ZM46.2222 15.372V16.8182H32V15.372H35.5519V10.7907C35.0484 10.458 34.6481 10.0477 34.3517 9.55985C34.055 9.07235 33.9067 8.51288 33.9067 7.88144V7.05512C33.9067 6.45853 34.0436 5.92198 34.3182 5.44565C34.5921 4.9697 34.9669 4.56194 35.4431 4.2233C35.9185 3.88504 36.4726 3.6269 37.105 3.44849C37.7371 3.27103 38.4061 3.18182 39.1111 3.18182C39.8163 3.18182 40.4848 3.27103 41.1174 3.44849C41.7496 3.6269 42.3035 3.88504 42.7793 4.2233C43.2549 4.56194 43.6299 4.9697 43.9042 5.44565C44.1785 5.92198 44.3155 6.45853 44.3155 7.05512V7.88144C44.3155 8.51288 44.167 9.07235 43.8706 9.55985C43.5739 10.0477 43.1739 10.458 42.6704 10.7907V15.372H46.2222Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ jsx("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M51.242 16.3547H58.0917V13.6507H51.242V16.3547ZM49.5968 17.7273H59.7369V12.1084H49.5968V17.7273ZM54.6502 5.90723C54.6051 6.00131 54.5098 6.10659 54.3646 6.22347C54.2191 6.34073 54.0456 6.45451 53.8441 6.56578C53.6428 6.67725 53.4355 6.78833 53.2231 6.89941C53.0102 7.01088 52.8144 7.10128 52.6356 7.17141C52.0647 7.40593 51.5216 7.62539 51.007 7.82997C50.4921 8.03493 49.9494 8.23681 49.3785 8.43579L48.7573 7.03116C49.4511 6.79702 50.0444 6.58626 50.537 6.39888C51.0294 6.21188 51.505 6.01869 51.964 5.81933C52.5235 5.5738 52.974 5.2989 53.3155 4.99444C53.6564 4.68999 53.8275 4.35057 53.8275 3.9756V3.7123H49.4121V2.27271H59.9214V3.7123H55.4894V3.9756C55.4894 4.35057 55.6573 4.6813 55.9931 4.96798C56.3289 5.25485 56.782 5.53284 57.3529 5.80214C57.8007 6.01271 58.2763 6.21188 58.7799 6.39888C59.2836 6.58626 59.8767 6.79702 60.5594 7.03116L59.9552 8.43579C59.3732 8.23681 58.8246 8.03493 58.3101 7.82997C57.7951 7.62539 57.2691 7.40593 56.7318 7.17141C56.5526 7.08989 56.3513 6.99581 56.1274 6.89052C55.9032 6.78505 55.6908 6.67397 55.4894 6.55709C55.2879 6.44022 55.1117 6.32585 54.9606 6.21439C54.8095 6.10331 54.7113 6.00131 54.6668 5.90723H54.6502ZM47.5557 10.6833H61.7779V9.20832H47.5557V10.6833Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ jsx("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M66.2222 16.8182H68.4444V3.18182H66.2222V16.8182Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ jsx("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M80.0001 3.18182H70.6667V5.45455H74.2134V16.8182H74.2578H76.4262H76.4534V5.45455H80.0001V3.18182Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ jsx("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M9.03772 0C8.20802 0 7.4456 0.470288 7.05208 1.22422L0.109089 14.5364C-0.214522 15.1567 0.220718 15.9091 0.903271 15.9091H11.4205L13.5792 11.7702L10.2722 4.9421C10.1223 4.63265 10.3402 4.26829 10.6757 4.26829H13.1468C13.4886 4.26829 13.8007 4.46754 13.9537 4.78301L15.528 8.03351L19.002 1.37284C19.3256 0.752384 18.8904 0 18.2078 0H9.03772Z",
                        fill: "url(#paint0_linear_5400_8961)"
                    }),
                    /*#__PURE__*/ jsx("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M21.1859 4.09094L15.439 15.238C15.2822 15.5418 14.9761 15.7317 14.6425 15.7317H11.3971L9.88688 18.6272C9.56308 19.2476 9.9985 20 10.6809 20H19.8511C20.6806 20 21.4434 19.5297 21.8365 18.7756L28.7797 5.46359C29.1035 4.84333 28.668 4.09094 27.9855 4.09094H21.1859Z",
                        fill: "url(#paint1_linear_5400_8961)"
                    })
                ]
            }),
            /*#__PURE__*/ jsxs("defs", {
                children: [
                    /*#__PURE__*/ jsxs("linearGradient", {
                        id: "paint0_linear_5400_8961",
                        x1: "9.55556",
                        y1: "0",
                        x2: "9.55556",
                        y2: "15.9091",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ jsx("stop", {
                                stopColor: "#8E2DE2"
                            }),
                            /*#__PURE__*/ jsx("stop", {
                                offset: "1",
                                stopColor: "#5A00DB"
                            })
                        ]
                    }),
                    /*#__PURE__*/ jsxs("linearGradient", {
                        id: "paint1_linear_5400_8961",
                        x1: "19.3333",
                        y1: "4.09094",
                        x2: "19.3333",
                        y2: "20",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ jsx("stop", {
                                stopColor: "#8E2DE2"
                            }),
                            /*#__PURE__*/ jsx("stop", {
                                offset: "1",
                                stopColor: "#5A00DB"
                            })
                        ]
                    }),
                    /*#__PURE__*/ jsx("clipPath", {
                        id: "clip0_5400_8961",
                        children: /*#__PURE__*/ jsx("rect", {
                            width: "80",
                            height: "20",
                            fill: "white"
                        })
                    })
                ]
            })
        ]
    });
    return /*#__PURE__*/ jsxs("svg", {
        width: "80",
        height: "20",
        viewBox: "0 0 80 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        "data-testid": "design-system-logo--yozmIT-symbol-text",
        children: [
            /*#__PURE__*/ jsxs("g", {
                clipPath: "url(#clip0_3475_339)",
                children: [
                    /*#__PURE__*/ jsx("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M39.1111 11.7376C38.4395 11.7376 37.8017 11.6575 37.1972 11.4967V15.372H41.025V11.4967C40.3981 11.6575 39.7602 11.7376 39.1111 11.7376ZM39.1111 4.66257C38.63 4.66257 38.1737 4.71995 37.7428 4.83473C37.3121 4.94931 36.9312 5.11295 36.6012 5.32526C36.2711 5.53776 36.0108 5.79855 35.8208 6.1084C35.6302 6.41825 35.5354 6.76238 35.5354 7.14117V7.79552C35.5354 8.17431 35.6302 8.51844 35.8208 8.82829C36.0108 9.13813 36.2711 9.39931 36.6012 9.61162C36.9312 9.82412 37.3121 9.98757 37.7428 10.1021C38.1737 10.2171 38.63 10.2743 39.1111 10.2743C39.5921 10.2743 40.0485 10.2171 40.4794 10.1021C40.9101 9.98757 41.2908 9.82412 41.6211 9.61162C41.9511 9.39931 42.2112 9.13813 42.4014 8.82829C42.5919 8.51844 42.687 8.17431 42.687 7.79552V7.14117C42.687 6.76238 42.5919 6.41825 42.4014 6.1084C42.2112 5.79855 41.9511 5.53776 41.6211 5.32526C41.2908 5.11295 40.9101 4.94931 40.4794 4.83473C40.0485 4.71995 39.5921 4.66257 39.1111 4.66257ZM46.2222 15.372V16.8182H32V15.372H35.5519V10.7908C35.0484 10.458 34.6481 10.0478 34.3517 9.55992C34.055 9.07242 33.9067 8.51295 33.9067 7.88151V7.05518C33.9067 6.45859 34.0436 5.92204 34.3182 5.44571C34.5921 4.96976 34.9669 4.562 35.4431 4.22336C35.9185 3.8851 36.4726 3.62696 37.105 3.44855C37.7371 3.27109 38.4061 3.18188 39.1111 3.18188C39.8163 3.18188 40.4848 3.27109 41.1174 3.44855C41.7496 3.62696 42.3035 3.8851 42.7793 4.22336C43.2549 4.562 43.6299 4.96976 43.9042 5.44571C44.1785 5.92204 44.3155 6.45859 44.3155 7.05518V7.88151C44.3155 8.51295 44.167 9.07242 43.8706 9.55992C43.5739 10.0478 43.1739 10.458 42.6704 10.7908V15.372H46.2222Z",
                        fill: "#212121"
                    }),
                    /*#__PURE__*/ jsx("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M51.242 16.3547H58.0917V13.6507H51.242V16.3547ZM49.5968 17.7273H59.7369V12.1084H49.5968V17.7273ZM54.6502 5.90723C54.6051 6.00131 54.5098 6.10659 54.3646 6.22347C54.2191 6.34073 54.0456 6.45451 53.8441 6.56578C53.6428 6.67725 53.4355 6.78833 53.2231 6.89941C53.0102 7.01088 52.8144 7.10128 52.6356 7.17141C52.0647 7.40593 51.5216 7.62539 51.007 7.82997C50.4921 8.03493 49.9494 8.23681 49.3785 8.43579L48.7573 7.03116C49.4511 6.79702 50.0444 6.58626 50.537 6.39888C51.0294 6.21188 51.505 6.01869 51.964 5.81933C52.5235 5.5738 52.974 5.2989 53.3155 4.99444C53.6564 4.68999 53.8275 4.35057 53.8275 3.9756V3.7123H49.4121V2.27271H59.9214V3.7123H55.4894V3.9756C55.4894 4.35057 55.6573 4.6813 55.9931 4.96798C56.3289 5.25485 56.782 5.53284 57.3529 5.80214C57.8007 6.01271 58.2763 6.21188 58.7799 6.39888C59.2836 6.58626 59.8767 6.79702 60.5594 7.03116L59.9552 8.43579C59.3732 8.23681 58.8246 8.03493 58.3101 7.82997C57.7951 7.62539 57.2691 7.40593 56.7318 7.17141C56.5526 7.08989 56.3513 6.99581 56.1274 6.89052C55.9032 6.78505 55.6908 6.67397 55.4894 6.55709C55.2879 6.44022 55.1117 6.32585 54.9606 6.21439C54.8095 6.10331 54.7113 6.00131 54.6668 5.90723H54.6502ZM47.5557 10.6833H61.7779V9.20832H47.5557V10.6833Z",
                        fill: "#212121"
                    }),
                    /*#__PURE__*/ jsx("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M66.2222 16.8182H68.4444V3.18188H66.2222V16.8182Z",
                        fill: "#212121"
                    }),
                    /*#__PURE__*/ jsx("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M80.0001 3.18188H70.6667V5.45461H74.2134V16.8182H74.2578H76.4262H76.4534V5.45461H80.0001V3.18188Z",
                        fill: "#212121"
                    }),
                    /*#__PURE__*/ jsx("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M9.03772 0C8.20802 0 7.4456 0.470288 7.05208 1.22422L0.109089 14.5364C-0.214522 15.1567 0.220718 15.9091 0.903271 15.9091H11.4205L13.5792 11.7702L10.2722 4.9421C10.1223 4.63265 10.3402 4.26829 10.6757 4.26829H13.1468C13.4886 4.26829 13.8007 4.46754 13.9537 4.78301L15.528 8.03351L19.002 1.37284C19.3256 0.752384 18.8904 0 18.2078 0H9.03772Z",
                        fill: "url(#paint0_linear_3475_339)"
                    }),
                    /*#__PURE__*/ jsx("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M21.1861 4.09094L15.4391 15.238C15.2824 15.5418 14.9762 15.7317 14.6427 15.7317H11.3972L9.887 18.6272C9.5632 19.2476 9.99863 20 10.681 20H19.8512C20.6807 20 21.4435 19.5297 21.8367 18.7756L28.7798 5.46359C29.1036 4.84333 28.6681 4.09094 27.9856 4.09094H21.1861Z",
                        fill: "url(#paint1_linear_3475_339)"
                    })
                ]
            }),
            /*#__PURE__*/ jsxs("defs", {
                children: [
                    /*#__PURE__*/ jsxs("linearGradient", {
                        id: "paint0_linear_3475_339",
                        x1: "9.55556",
                        y1: "0",
                        x2: "9.55556",
                        y2: "15.9091",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ jsx("stop", {
                                stopColor: "#8E2DE2"
                            }),
                            /*#__PURE__*/ jsx("stop", {
                                offset: "1",
                                stopColor: "#5A00DB"
                            })
                        ]
                    }),
                    /*#__PURE__*/ jsxs("linearGradient", {
                        id: "paint1_linear_3475_339",
                        x1: "19.3334",
                        y1: "4.09094",
                        x2: "19.3334",
                        y2: "20",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ jsx("stop", {
                                stopColor: "#8E2DE2"
                            }),
                            /*#__PURE__*/ jsx("stop", {
                                offset: "1",
                                stopColor: "#5A00DB"
                            })
                        ]
                    }),
                    /*#__PURE__*/ jsx("clipPath", {
                        id: "clip0_3475_339",
                        children: /*#__PURE__*/ jsx("rect", {
                            width: "80",
                            height: "20",
                            fill: "white"
                        })
                    })
                ]
            })
        ]
    });
};

export { YozmITSymbolText as default };
